import React from 'react';
import { UIText1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormError = function FormError(_ref) {
  var children = _ref.children;
  var deviceType = useDeviceType();
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles['container'], styles[deviceType]),
    "data-testid": "leave-contacts-modal-error",
    children: /*#__PURE__*/_jsx(UIText1, {
      color: "error_100",
      children: children
    })
  });
};